<script setup lang="ts">
import { useAuthStore } from "@/stores/auth";
import { navItems } from "@/router";
import PermissionBoundary from "./PermissionBoundary.vue";
interface Props {
  isHidden?: boolean;
}
withDefaults(defineProps<Props>(), {
  isHidden: false,
});

const { logout } = useAuthStore();
</script>

<template>
  <header class="navbar bg-base-200 mb-4" :class="{ hidden: isHidden }">
    <div class="navbar-start">
      <div class="dropdown">
        <p tabindex="0" class="btn btn-ghost lg:hidden">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h8m-8 6h16"
            />
          </svg>
        </p>
        <ul
          tabindex="0"
          class="menu menu-sm dropdown-content mt-3 p-2 shadow bg-base-200 rounded-box w-52 z-10"
        >
          <li v-for="item in navItems">
            <router-link class="nav-link" :to="item.to">{{
              $t(item.label)
            }}</router-link>
          </li>
        </ul>
      </div>
      <router-link
        class="btn btn-ghost normal-case text-xl px-0 lg:px-4"
        to="/home"
        >{{ $t("common.promas") }}</router-link
      >
      <ul class="menu menu-horizontal px-1 hidden lg:flex">
        <PermissionBoundary
          v-for="item in navItems"
          :permissions="item.permissions"
        >
          <li>
            <router-link class="nav-link" :to="item.to">{{
              $t(item.label)
            }}</router-link>
          </li>
        </PermissionBoundary>
      </ul>
    </div>
    <div class="navbar-end">
      <ul class="menu menu-horizontal px-1">
        <li>
          <router-link to="/" @click="logout">{{
            $t("common.logout")
          }}</router-link>
        </li>
      </ul>
    </div>
  </header>
</template>

<style scoped>
@reference "../../css/app.css";

.nav-link.router-link-active {
  @apply bg-primary text-primary-content;
}

.navbar-start {
  width: 60%;
}

.navbar-end {
  width: 40%;
}
</style>
